<template>
	<v-app>
		<v-row class="px-4">

      <v-col cols="12">
        <v-card
          elevation="0"
          style="margin-top: 15px;">
          <v-card-title>
            <v-row>
              <v-col>
                Rapport PDF
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card
          elevation="0"
        >
          <v-card-text>
            <pdf-viewer :pdf_blob="pdf_blob" />
          </v-card-text>
        </v-card>
      </v-col>
		</v-row>
	</v-app>
</template>

<script>

import api from "@/api/api";
import PdfViewer from '@/components/Utils/PdfViewer'


export default {
	components: {
    PdfViewer,
	},

	data() {
		return {
      loading: false,
      pdf_blob: null,

			// Params
			installation_id: this.$route.params.id,
		};
	},

	computed: {
		installation() {
			return this.$store.getters.installations.find(
				(x) => x.id == this.installation_id
			)
		},

	},

	watch: {
		route: {
			handler() {
        this.installation_id = this.$route.params.id
        this.getPDF()
      },
			immediate: true,
		},

	},

	methods: {
    getPDF() {
      //console.log('Trying to get PDF')
      api
        .getPDFUrl('6d03481f-bc85-4808-91f8-2f39b51301b9')
        .then(response => {
          // this.pdf_blob = new Blob([response.data])
          this.pdf_blob = response.data
        }).catch(console.error)
    },
	},
};
</script>

<style>
</style>
